
import { defineComponent, ref, watch } from 'vue'
import { Field } from 'vee-validate'
import Datepicker from 'vue3-datepicker'

export default defineComponent({
  name: 'QDatePicker',
  inheritAttrs: true,
  components: {
    Field,
    Datepicker
  },
  setup(props, context) {
    const date = ref(context.attrs.modelValue)

    const addHighlight = () => {
      document
        ?.querySelector('.q-field.datepicker')
        ?.classList.add('q-field--highlighted')
    }

    watch(date, () => {
      document
        ?.querySelector('.q-field.datepicker')
        ?.classList.remove('q-field--highlighted')
    })

    return { date, addHighlight }
  }
})
